import { gql } from 'apollo-angular'

export default gql`
  query microsoftLogin($idToken: String!) {
    microsoftLogin(data: { idToken: $idToken }) {
      token
      permissions
      user {
        accountType
        username
        id
        role
        firstName
        lastName
        email
        facility {
          id
          name
        }
      }
    }
  }
`
